import cn from 'classnames';
import { TPlansDetails } from 'src/types/plans.types';
import PlanInfo from '../PlanInfo';
import SelectPlanRadio from '../SelectPlanRadio';
import styles from './pricing.module.scss';

type HeaderRowProps = {
  radioGroupLabel: string;
  smartHomePlan: TPlansDetails['smartHome'];
  secondaryPlan: TPlansDetails['secondary'];
  annualSavings: string;
  billingCycle: string;
  setBillingCycle: BaseAnyFunction;
};
const HeaderRow = ({ radioGroupLabel, smartHomePlan, secondaryPlan, annualSavings, billingCycle, setBillingCycle }: HeaderRowProps) => (
  <div className={cn(styles.row, styles.headerContainer)}>
    <div className={cn('paddingTop-medium1', styles.selectPlanCol)}>
      <h3 className={styles.title}>{radioGroupLabel}:</h3>
      <SelectPlanRadio billingCycle={billingCycle} setBillingCycle={setBillingCycle} annualSavings={annualSavings} />
    </div>
    <div className={cn('paddingTop-medium1', styles.smartHomeCol)}>
      <PlanInfo billingCycle={billingCycle} planInfo={smartHomePlan} />
    </div>
    <div className={cn('paddingTop-medium1', styles.secondaryCol)}>
      <PlanInfo billingCycle={billingCycle} planInfo={secondaryPlan} />
    </div>
  </div>
);

export default HeaderRow;
